import React from 'react';
import './PasswordInput.css';
import {Input} from "../Input/Input";

export const PasswordInput = (options) => {
  return (<Input type="password" {...options} />);
};